export const errorSymbol: unique symbol = Symbol.for('@atlassian/react-loosely-lazy/loader-error');

export const createLoaderError = (error: unknown): {} | undefined => {
	if (typeof error === 'object') {
		// @ts-expect-error Explicitly untyped
		return Object.assign(error, { [errorSymbol]: true });
	}

	return error;
};

export const isLoaderError = (error: unknown): boolean =>
	Object.getOwnPropertySymbols(error).includes(errorSymbol);
